import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ValidationRulesState } from './reducers/validation-rules.reducer';

export const validationRulesStateKey = 'validationRules';

const selectFeature = createFeatureSelector<ValidationRulesState>(validationRulesStateKey);

export const selectValidationRulesState = createSelector(selectFeature, (state) => state);
